import React, { useState } from "react";
import { useLocation, useNavigate, Link, NavLink } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { REACT_APP_API_URL } from "../../env";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { fetchUserDetails } from "../../store/slice/features/authSlice";
import { useDispatch } from "react-redux";

const Login = () => {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const isValidIdentifier = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const phoneRegex = /^[0-9]{10}$/;
    const userIdRegex = /^[a-zA-Z0-9_]{3,}$/;
    return emailRegex.test(input) || phoneRegex.test(input) || userIdRegex.test(input);
  };

  const handleSignIn = async (e) => {
    e.preventDefault();

    if (!isValidIdentifier(identifier)) {
      toast.error("Please enter a valid email, phone number, or user ID.");
      return;
    }

    if (password.length < 6) {
      toast.error("Password must be at least 6 characters long.");
      return;
    }

    try {
      const response = await axios.post(
        `${REACT_APP_API_URL}/api/auth/login`,
        {
          identifier,
          password,
        },
        { withCredentials: true }
      );

      dispatch(fetchUserDetails());

      if (response.status === 200) {
        toast.success("Login successful");
        const from = location.state?.from || "/";
        navigate(from);
      }
    }
    catch (error) {
      console.error("Login error:", error);
      toast.error(
        error.response?.data?.message ||
        "Login failed. Please check your credentials."
      );
    }
  };

  return (
    <div className="login-background-image d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
      <div className="container" style={{ maxWidth: "400px" }}>
        <form
          className="p-4 rounded text-center"
          style={{ backgroundColor: "rgba(63, 61, 61, 0.7)" }}
          onSubmit={handleSignIn}
        >
          <div className="d-flex justify-content-center mb-2">
            <NavLink to="/">
              <img
                src="images/logo/JTDC.png"
                style={{ width: "200px", cursor: "pointer" }}
                alt="Logo"
                loading="lazy"
              />
            </NavLink>
          </div>

          <h5 className="text-center text-white auth-page-title">Login</h5>

          <div className="form-group-signup">

            <input
              type="text"
              className="form-control"
              id="identifier"
              placeholder="Enter Email or Phone"
              required
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
            />
            {!isValidIdentifier(identifier) && identifier.length > 0 && (
              <small className="text-danger">
                Enter a valid email, phone number, or user ID.
              </small>
            )}
          </div>

          <div className="form-group-signup position-relative">
            <div className="position-relative">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control pe-5"
                id="password"
                placeholder="Enter Password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                className="position-absolute d-flex align-items-center"
                style={{
                  top: "50%",
                  right: "15px",
                  transform: "translateY(-50%)",
                  cursor: "pointer",
                }}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <div className="text-center mt-3">
            <Link
              to="/forgot-password"
              style={{ color: "#ffeb3b", fontStyle: "italic" }}
            >
              Forgot Password?
            </Link>
          </div>

          <div className="d-flex justify-content-center mt-10">
            <button
              type="submit"
              className="btn btn-block"
              style={{ backgroundColor: "#4b9f16", color: "white" }}
            >
              Login
            </button>
          </div>

          <p className="text-center mt-2 text-white">
            Don't have an account?{" "}
            <Link
              to="/signup"
              style={{
                color: "#ffeb3b",
                textDecoration: "underline",
                fontStyle: "italic",
              }}
            >
              Signup
            </Link>
          </p>

          <p className="text-center mt-2 text-white">
            Login as{" "}
            <Link
              to="https://jtdclportal.jharkhand.gov.in/signin"
              style={{
                color: "#ffeb3b",
                textDecoration: "underline",
                fontStyle: "italic",
              }}
            >
              Admin/Manager
            </Link>
          </p>
        </form>
      </div>
    </div>
  );
};

export default Login;